import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text, Image } from 'rebass/styled-components';

import { Button } from '@getro/rombo';
import { networkTypes } from 'helpers/networkTypes';

export const NetworkKind = ({ updateNetworkKind, networkKind, network, isLoadingUpdateNetworkKind }) => (
  <Flex
    sx={{
      mx: 'auto',
      mt: '100px',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '40px',
    }}
  >
    <Flex sx={{ flexDirection: 'column', gap: '16px', alignItems: ['flex-start', 'center', 'center'], width: '100%' }}>
      <Text as="h1" fontSize="22px" fontWeight="600" lineHeight="1.2">
        What best describes {network.name}?
      </Text>
      <Text color="text.main" fontSize="16px">
        We’ll tailor your experience to help you unlock the right intros.
      </Text>
    </Flex>
    <Flex
      sx={{
        flexDirection: ['column', 'row', 'row'],
        gap: '16px',
      }}
    >
      {networkTypes.map((type) => (
        <Box
          key={type.id}
          sx={{
            border: '1px solid',
            borderColor: 'border.subtle',
            borderRadius: '8px',
            p: '16px',
            maxWidth: ['100%', '312px', '312px'],
            width: '100%',
          }}
        >
          <Image src={type.icon} />
          <Flex sx={{ flexDirection: 'column', gap: '16px' }}>
            <Text>
              <Text as="p" fontWeight="500" fontSize="14px" lineHeight="1.4" color="text.dark">
                {type.name}
              </Text>
              <Text as="p" fontWeight="400" fontSize="14px" lineHeight="1.4" color="text.main">
                {type.description}
              </Text>
            </Text>
            <Button
              loading={isLoadingUpdateNetworkKind && type.id === networkKind}
              variant="primary"
              sx={{ width: '100%', justifyContent: 'center' }}
              onClick={() => updateNetworkKind(type.id)}
            >
              Select
            </Button>
          </Flex>
          <Flex sx={{ flexDirection: 'row', gap: '16px', mt: '40px', justifyContent: 'center' }}>
            {type.icons.map((icon) => (
              <Image src={icon} key={icon.toString()} />
            ))}
          </Flex>
        </Box>
      ))}
    </Flex>
  </Flex>
);

NetworkKind.propTypes = {
  updateNetworkKind: PropTypes.func.isRequired,
  network: PropTypes.object.isRequired,
  isLoadingUpdateNetworkKind: PropTypes.bool.isRequired,
  networkKind: PropTypes.string.isRequired,
};
